import { ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid-premium';

const MAX_INVOICE_NO_LEN = 16;

const InvoiceNoEditCell = (props: GridRenderEditCellParams) => {
  const { id, field, value, api } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const next = (e.target.value ?? '').toString().slice(0, MAX_INVOICE_NO_LEN);

    api.setEditCellValue({ id, field, value: next }, e);
  };

  return (
    <TextField
      value={(value ?? '').toString().slice(0, MAX_INVOICE_NO_LEN)}
      onChange={handleChange}
      fullWidth
      autoFocus
      sx={{
        '.MuiInputBase-root': {
          height: '50px',
          border: 'none',
          borderRadius: 0,
          backgroundColor: (theme) => {
            if (theme.palette.mode === 'light') return 'rgba(120, 190, 255, 0.20)';
            return 'rgba(120, 190, 255, 0.15)';
          },
        },
      }}
      slotProps={{
        htmlInput: {
          maxLength: MAX_INVOICE_NO_LEN,
        },
      }}
    />
  );
};

export default InvoiceNoEditCell;
